import { getConditionalArray } from 'utils/data';

import { getWarehouseBanksAction } from 'store/accounting/actions';
import { loadCustomFieldsAction } from 'store/customFieldDefinitions/actions';
import { getFormBundlesAction, getFormsInfoAction } from 'store/forms/actions';
import { getRolesAction } from 'store/global/actions';
import { loadHalcyonFormCatalogAction } from 'store/loanActions/halcyonFormCatalog';
import { loadServicelinkFloodProductsAction } from 'store/loanActions/servicelinkFloodProducts';
import { loadLoanEditorCustomFormsAction } from 'store/loanEditorCustomForms/actions';
import {
  getAiProcessesAction,
  getChecklistsAction,
  getDocumentTypesAction,
  getEmailTemplateCategoriesAction,
  getHalcyonFormInclusionSchemaAction,
  getImpoundTypesAction,
  getLoanActionArithmeticOperationsSchemaAction,
  getLoanActionCriteriaSchemaAction,
  getLoanActionPossibleFieldsAction,
  getLoanRoleAssignmentCriteriaSchemaAction,
  getLoanRolesAction,
  getProvidersAction,
  getTagsAction,
  getTaskCategoriesAction,
  getTaskTypesWithExclusionAction,
} from 'store/system/actions';
import { getUsersAction } from 'store/users/actions';

/**
 * Dispatches every directory the manual loan-action item editor reads.
 * `isHostDirectoriesLoaded` skips the directories a host page already loads with its own params
 * (roles, loan roles, users, task types/categories, document types) so they are not overwritten.
 * @returns {Array<Promise>}
 */
export const loadLoanActionItemsDependencies = ({
  dispatch,
  isCustomFormsViewAllowed,
  isHostDirectoriesLoaded = false,
}) => [
  ...getConditionalArray(!isHostDirectoriesLoaded, () => [dispatch(getRolesAction())]),
  dispatch(getLoanActionCriteriaSchemaAction()),
  dispatch(getLoanActionArithmeticOperationsSchemaAction()),
  dispatch(getHalcyonFormInclusionSchemaAction()),
  dispatch(getLoanActionPossibleFieldsAction()),
  dispatch(getTagsAction({ includeDeleted: true })),
  dispatch(getFormsInfoAction()),
  dispatch(getFormBundlesAction({ includeElements: true })),
  dispatch(getChecklistsAction()),
  ...getConditionalArray(!isHostDirectoriesLoaded, () => [dispatch(getDocumentTypesAction())]),
  dispatch(getEmailTemplateCategoriesAction()),
  ...getConditionalArray(!isHostDirectoriesLoaded, () => [dispatch(getLoanRolesAction())]),
  dispatch(getImpoundTypesAction({ includeDeleted: true })),
  ...getConditionalArray(!isHostDirectoriesLoaded, () => [
    dispatch(getTaskTypesWithExclusionAction()),
    dispatch(getTaskCategoriesAction()),
  ]),
  dispatch(getLoanRoleAssignmentCriteriaSchemaAction()),
  dispatch(getWarehouseBanksAction()),
  dispatch(loadHalcyonFormCatalogAction()),
  dispatch(loadServicelinkFloodProductsAction()),
  dispatch(getProvidersAction({ silent: true, skipResponseInterceptor: { forbiddenError: true } })),
  dispatch(getAiProcessesAction({ silent: true })),
  dispatch(loadCustomFieldsAction()),
  ...getConditionalArray(!isHostDirectoriesLoaded, () => [dispatch(getUsersAction())]),
  ...getConditionalArray(isCustomFormsViewAllowed, () => [
    dispatch(loadLoanEditorCustomFormsAction({ includeGlobal: true })),
  ]),
];
